/* ============================================================
   EZWN — Cartes "differente" (page produit)
   - Desktop (souris) : inclinaison 3D au survol.
   - Mobile (tactile) : la carte CENTREE du carrousel devient
     active automatiquement quand on swipe (.is-active).
   S'ajoute par-dessus ezwn-fx.js. Respecte "animations reduites".
   ============================================================ */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var reduced = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover:hover) and (pointer:fine)');

  function grid() { return document.querySelector('.ezp-diff__grid'); }
  function cardsOf(g) { return Array.prototype.slice.call(g.querySelectorAll('.ezp-card')); }

  /* ---------- Desktop : inclinaison 3D au survol ---------- */
  function bindCardTilt(card) {
    var raf = null;
    card.addEventListener('pointermove', function (ev) {
      var r = card.getBoundingClientRect();
      var px = (ev.clientX - r.left) / r.width - 0.5;
      var py = (ev.clientY - r.top) / r.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.transform =
          'perspective(900px) translateY(-6px) rotateY(' +
          (px * 8).toFixed(2) + 'deg) rotateX(' +
          (-py * 8).toFixed(2) + 'deg)';
      });
    });
    card.addEventListener('pointerleave', function () {
      if (raf) cancelAnimationFrame(raf);
      card.style.transform = '';
    });
  }
  function initDesktopTilt() {
    if (reduced || !fine) return;
    var g = grid(); if (!g) return;
    cardsOf(g).forEach(bindCardTilt);
  }

  /* ---------- Mobile : carte centree = active (au swipe) ---------- */
  function initMobileActive() {
    if (reduced || fine) return;
    var g = grid(); if (!g) return;
    var cards = cardsOf(g);
    if (cards.length < 2) return;

    function isCarousel() { return g.scrollWidth > g.clientWidth + 4; }
    var raf = null;

    function update() {
      if (!isCarousel()) { cards.forEach(function (c) { c.classList.remove('is-active'); }); return; }
      var gr = g.getBoundingClientRect();
      var center = gr.left + gr.width / 2;
      var best = null, bestDist = Infinity;
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - center);
        if (d < bestDist) { bestDist = d; best = c; }
      });
      cards.forEach(function (c) { c.classList.toggle('is-active', c === best); });
    }
    function onScroll() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }

    g.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setTimeout(update, 80);
  }

  function boot() { initDesktopTilt(); initMobileActive(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
